import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  Alert,
  Card,
  CardBody,
  CardImg,
  CardTitle,
  Col,
  ListGroup,
  ListGroupItem,
  Row,
  Spinner,
} from "reactstrap";
import playerImage from "../../../../assets/images/playerExemple.jpeg";
import { FaUserCircle } from "react-icons/fa";
import { API_URL } from "constants/ApiUrl";
import { useEffect, useState } from "react";

const AgentPlayerProfile = () => {
  const { t } = useTranslation();
  const { getProfileLoading, player, error } = useSelector(
    (state) => state.AgentPlayer
  );
  const [playerPhoto, setPlayerPhoto] = useState(null);
  useEffect(() => {
    if (player?.photo) {
      const cleanApiUrl = API_URL.replace(/\/+$/, '');
      let cleanPhoto = player?.photo.replace(/^\/+/, '');
      cleanPhoto = player?.photo.split('/').pop();
      if (!cleanPhoto.includes('uploads/')) {
        cleanPhoto = 'uploads/' + cleanPhoto;
      }

      setPlayerPhoto(`${cleanApiUrl}/${cleanPhoto}`);
    }
  }, [player])
  if (getProfileLoading) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <Spinner color="primary" />
        <div>Chargement en cours...</div>
      </div>
    );
  }

  if (error) return <Alert color="danger">{error.message}</Alert>;
  const formatDate = (iso) =>
    iso ? new Date(iso).toLocaleDateString("fr-FR") : "-";

  return (
    <Card className="p-3">
      <Row>
        <Col md="4" className="text-center">
          {playerPhoto ? (
            <CardImg
              top
              src={playerPhoto}
              alt={`${player?.firstName} ${player?.lastName}`}
              style={{ maxWidth: "200px", margin: "0 auto" }}
            />
          ) : (
            <FaUserCircle size={72} className="text-secondary" style={{ marginRight: "15px" }} />
            // <CardImg
            //   top
            //   src={playerImage}
            //   alt={`${player?.firstName} ${player?.lastName}`}
            //   style={{ maxWidth: "200px", margin: "0 auto" }}
            // />
          )}
          <CardBody>
            <CardTitle tag="h5">
              {player?.firstName} {player?.lastName}
            </CardTitle>
            <div className="text-muted">{player?.category}</div>
          </CardBody>
        </Col>

        <Col md="8">
          <ListGroup flush>
            <ListGroupItem>
              <strong>{t("playerInfo.profile.username")}:</strong>{" "}
              {player?.username}
            </ListGroupItem>
            <ListGroupItem>
              <strong>{t("playerInfo.profile.email")}:</strong> {player?.email}
            </ListGroupItem>
            <ListGroupItem>
              <strong>{t("playerInfo.profile.phone")}:</strong> {player?.phone}
            </ListGroupItem>
            <ListGroupItem>
              <strong>{t("playerInfo.profile.dateOfBirth")}:</strong>{" "}
              {formatDate(player?.dateOfBirth)}
            </ListGroupItem>
            <ListGroupItem>
              <strong>{t("playerInfo.profile.nationality")}:</strong>{" "}
              {player?.nationality}
            </ListGroupItem>
            <ListGroupItem>
              <strong>{t("playerInfo.profile.currentClub")}:</strong>{" "}
              {player?.currentClub}
            </ListGroupItem>
            <ListGroupItem>
              <strong>{t("playerInfo.profile.position")}:</strong>{" "}
              {player?.position}
            </ListGroupItem>
            <ListGroupItem>
              <strong>{t("playerInfo.profile.height")}:</strong>{" "}
              {player?.height} cm
            </ListGroupItem>
            <ListGroupItem>
              <strong>{t("playerInfo.profile.weight")}:</strong>{" "}
              {player?.weight} kg
            </ListGroupItem>
            <ListGroupItem>
              <strong>{t("playerInfo.profile.biography")}:</strong>{" "}
              {player?.biography}
            </ListGroupItem>
            <ListGroupItem>
              <strong>{t("playerInfo.profile.subscription")}:</strong>{" "}
              {formatDate(player?.subscriptionStartDate)} –{" "}
              {formatDate(player?.subscriptionEndDate)}
            </ListGroupItem>
          </ListGroup>
        </Col>
      </Row>
    </Card>
  );
};

const styles = {
  titreInfo: {
    color: "#000000",
  },
  infoProfile: {
    marginBottom: "18px",
    fontSize: "18px",
    font: "Poppins",
  },

  statInfo: {
    marginBottom: "18px",
    fontSize: "16px",
    font: "Poppins",
  },
  listeItem: {
    marginBottom: 2,
  },
};
export default AgentPlayerProfile;
